<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="HPV Quadrivalente"
            description="Situação vacinal de crianças com HPV Quadrivalente"
            url="/imunizacao/vacina-idade-certa"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'HPV Quadrivalente',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
